import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { faComment as faCommentRegular } from '@fortawesome/pro-regular-svg-icons';
import { faComment as faCommendDuotone } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { PresenceStatusState } from '../../../store/samwin/contact-states/presence-status/presence-status.state';

@Component({
   selector: 'samweb-presence-status-note',
   templateUrl: './presence-status-note.component.html',
   styleUrls: ['./presence-status-note.component.scss'],
})
export class PresenceStatusNoteComponent implements AfterViewInit, OnDestroy, OnChanges {
   constructor(private store: Store) {}
   private destroy$ = new Subject();

   public noCommentIcon = faCommentRegular;
   public commentIcon = faCommendDuotone;

   @Input()
   public fixedWidth: boolean;

   @Input()
   public presenceId: string;

   @Input()
   public presenceTypeValue: number;

   public presenceNote$: Observable<string>;

   // Is needed for virtual scrolling, the data would not update correctly otherwise.
   ngOnChanges(changes: SimpleChanges): void {
      if (
         changes?.presenceId?.previousValue !== changes?.presenceId?.currentValue ||
         changes?.presenceTypeValue?.previousValue !== changes?.presenceTypeValue?.currentValue
      ) {
         this.ngAfterViewInit();
      }
   }

   ngAfterViewInit(): void {
      this.presenceNote$ = this.store.select(PresenceStatusState.getPresenceStateSelector(this.presenceId, this.presenceTypeValue)).pipe(
         map((x) => (_.isNil(x.presenceState) ? null : x.presenceState.note)),
         takeUntil(this.destroy$)
      );
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
